import { useCallback, useEffect, useRef } from "react";
import { scheduleRefresh } from "../authUtils";

export default function useTokenRefreshScheduler({
  token,
  refreshToken,
  enabled = true,
}) {
  const refreshTimeoutRef = useRef(null);

  const clearScheduledRefresh = useCallback(() => {
    if (refreshTimeoutRef.current) {
      clearTimeout(refreshTimeoutRef.current);
      refreshTimeoutRef.current = null;
    }
  }, []);

  useEffect(() => {
    clearScheduledRefresh();

    if (enabled && token) {
      refreshTimeoutRef.current = scheduleRefresh(token, refreshToken);
    }

    return clearScheduledRefresh;
  }, [clearScheduledRefresh, enabled, refreshToken, token]);

  return clearScheduledRefresh;
}
